import React from "react";

const MediaSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 64 64"
    >
      <g>
        <g
          xmlns="http://www.w3.org/2000/svg"
          id="media-monitor-screen-Digital_Marketing"
          data-name="media-monitor-screen-Digital Marketing"
        >
          <path
            d="m59 15h-2v-1h1a3 3 0 0 0 0-6h-1v-5a.968.968 0 0 0 -.41-.8.991.991 0 0 0 -.88-.16l-12.86 3.96h-6.85a1 1 0 0 0 -1 1v1h-2a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h2v1h-6v-9a1 1 0 0 0 -1-1h-20a1 1 0 0 0 -1 1v9h-2a3.009 3.009 0 0 0 -3 3v32a3.009 3.009 0 0 0 3 3h23v3h-6a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-4a1 1 0 0 0 -1-1h-6v-3h23a3.009 3.009 0 0 0 3-3v-32a3.009 3.009 0 0 0 -3-3zm-2-5h1a1 1 0 0 1 0 2h-1zm-13-2.26 11-3.39v13.3l-11-3.39zm-7 .26h5v6h-5zm2.85 8-.72 5h-1.13v-5zm-5.85-4v-2h1v2zm-25-5h18v14h-18zm32 51v2h-18v-2zm-11-2v-3h4v3zm30-6a1 1 0 0 1 -1 1h-54a1 1 0 0 1 -1-1v-1h56zm0-3h-56v-29a1 1 0 0 1 1-1h2v5a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-5h7v5a1 1 0 0 0 1 1h3a1 1 0 0 0 .99-.86l.88-6.14h.98l12.86 3.96a.925.925 0 0 0 .29.04 1.015 1.015 0 0 0 1-1v-2h2a1 1 0 0 1 1 1z"
            fill="#fb4a5b"
            data-original="#000000"
          />
          <path
            d="m7 45h26a1 1 0 0 0 1-1v-16a1 1 0 0 0 -1-1h-26a1 1 0 0 0 -1 1v16a1 1 0 0 0 1 1zm1-2v-13.211l11.476 7.063a1 1 0 0 0 1.048 0l11.476-7.063v13.211zm2.533-14h18.934l-9.467 5.826z"
            fill="#fb4a5b"
            data-original="#000000"
          />
          <path
            d="m37 39h2v3a1 1 0 0 0 1 1h17a1 1 0 0 0 1-1v-12a1 1 0 0 0 -1-1h-1v-3a1 1 0 0 0 -1-1h-18a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1zm19 2h-15v-10h15zm-18-14h16v2h-14a1 1 0 0 0 -1 1v7h-1z"
            fill="#fb4a5b"
            data-original="#000000"
          />
          <path d="m43 33h2v2h-2z" fill="#fb4a5b" data-original="#000000" />
          <path d="m47 33h7v2h-7z" fill="#fb4a5b" data-original="#000000" />
          <path d="m43 37h4v2h-4z" fill="#fb4a5b" data-original="#000000" />
          <path d="m49 37h5v2h-5z" fill="#fb4a5b" data-original="#000000" />
          <path
            d="m15.474 17.851a1 1 0 0 0 .973.044l6-3a1 1 0 0 0 0-1.79l-6-3a1 1 0 0 0 -1.447.895v6a1 1 0 0 0 .474.851zm1.526-5.233 2.764 1.382-2.764 1.382z"
            fill="#fb4a5b"
            data-original="#000000"
          />
        </g>
      </g>
    </svg>
  );
};

export default MediaSvg;
